import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css"
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "react-bootstrap-multiselect/css/bootstrap-multiselect.css";
// // import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

